import { render, staticRenderFns } from "./tabBuyerConsoleFclContainer.vue?vue&type=template&id=45b5eed6&"
import script from "./tabBuyerConsoleFclContainer.vue?vue&type=script&lang=js&"
export * from "./tabBuyerConsoleFclContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b5eed6')) {
      api.createRecord('45b5eed6', component.options)
    } else {
      api.reload('45b5eed6', component.options)
    }
    module.hot.accept("./tabBuyerConsoleFclContainer.vue?vue&type=template&id=45b5eed6&", function () {
      api.rerender('45b5eed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabBuyerConsoleFclContainer.vue"
export default component.exports